// extracted by mini-css-extract-plugin
export default {"inputHeader":"ManageCreditReasonField_inputHeader__I5XQ6","selectReason":"ManageCreditReasonField_selectReason__2arH2","entityInput":"ManageCreditReasonField_entityInput__isHsW"};